var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { TYPES } from '@/dependency-injection/types';
import { ApiClient } from '@/services/base-axios-client';
import { injectable, inject } from 'inversify';
import { ReportFiltersVm } from '@/typings';
import { AuthService } from '@/services/auth-service';
var ProfileService = /** @class */ (function (_super) {
    __extends(ProfileService, _super);
    function ProfileService(authSvc) {
        var _this = _super.call(this, '/api/v1/') || this;
        _this.authService = authSvc;
        return _this;
    }
    ProfileService.prototype.getDefaultReportFiltersVm = function () {
        return new ReportFiltersVm();
    };
    ProfileService.prototype.getDefaultChangePasswordVm = function () {
        return {};
    };
    Object.defineProperty(ProfileService.prototype, "hasVoyageLoadListPriv", {
        get: function () {
            return this.authService.isAuthorized('PROFILE', 'ALL', 'RF#VOYAGELIST');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProfileService.prototype, "hasOpportunityPriv", {
        get: function () {
            return this.authService.isAuthorized('PROFILE', 'ALL', 'RF#CLAIMS');
        },
        enumerable: false,
        configurable: true
    });
    ProfileService.prototype.getContactVm = function () {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        endpoint = 'profile/getcontact';
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, {})];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        error_1 = _a.sent();
                        console.error("Unable to get contact");
                        console.error(error_1);
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ProfileService.prototype.getReportFiltersVm = function () {
        return __awaiter(this, void 0, Promise, function () {
            var vllEndpoint, oppEndpoint, rfVM, vllResponse, oppLoadsResponse, oppActionsResponse, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        vllEndpoint = 'profile/getvoyageloadlist';
                        oppEndpoint = 'filter/GetFilters';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 7, , 8]);
                        rfVM = {};
                        if (!this.hasVoyageLoadListPriv) return [3 /*break*/, 3];
                        return [4 /*yield*/, _super.prototype.post.call(this, vllEndpoint, {})];
                    case 2:
                        vllResponse = _a.sent();
                        if (vllResponse.status === 200) {
                            rfVM.voyageLoadListVm = vllResponse.data;
                        }
                        _a.label = 3;
                    case 3:
                        if (!this.hasOpportunityPriv) return [3 /*break*/, 6];
                        return [4 /*yield*/, _super.prototype.post.call(this, oppEndpoint, {
                                Module: 'OPPORTUNITY_LOADS',
                            })];
                    case 4:
                        oppLoadsResponse = _a.sent();
                        if (oppLoadsResponse.status === 200) {
                            rfVM.filterVm = oppLoadsResponse.data.data;
                        }
                        return [4 /*yield*/, _super.prototype.post.call(this, oppEndpoint, {
                                Module: 'OPPORTUNITY_ACTIONS',
                            })];
                    case 5:
                        oppActionsResponse = _a.sent();
                        if (oppActionsResponse.status === 200) {
                            rfVM.filterVm = oppActionsResponse.data.data.concat(rfVM.filterVm);
                        }
                        _a.label = 6;
                    case 6: return [2 /*return*/, rfVM];
                    case 7:
                        error_2 = _a.sent();
                        console.error(error_2);
                        throw error_2;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    ProfileService.prototype.saveContactVm = function (contact) {
        return __awaiter(this, void 0, void 0, function () {
            var endpoint, data, response, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = 'profile/savecontact';
                        data = __assign({}, contact);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, {
                                FirstName: data.firstName,
                                LastName: data.lastName,
                                Email: data.email,
                                DisableEmailNotifications: data.disableEmailNotifications,
                                OfficePhone: data.officePhone,
                                CellPhone: data.cellPhone,
                            })];
                    case 2:
                        response = _a.sent();
                        if (response.status === 200) {
                            return [2 /*return*/, response.data];
                        }
                        else {
                            throw new Error(response.data);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        console.error("Unable to save contact");
                        console.error(error_3);
                        throw error_3;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ProfileService.prototype.saveReportFiltersVm = function (filters) {
        return __awaiter(this, void 0, void 0, function () {
            var data, vllEndpoint, vllResponse, oppEndpoint, oppResponse, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = __assign({}, filters);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        if (!this.hasVoyageLoadListPriv) return [3 /*break*/, 3];
                        vllEndpoint = 'profile/savevoyageloadlist';
                        return [4 /*yield*/, _super.prototype.post.call(this, vllEndpoint, {
                                FromDate: data.voyageLoadListVm.fromDate,
                                ToDate: data.voyageLoadListVm.toDate,
                                View: data.voyageLoadListVm.view,
                                Group: data.voyageLoadListVm.group,
                                Site: data.voyageLoadListVm.site,
                                Market: data.voyageLoadListVm.market,
                            })];
                    case 2:
                        vllResponse = _a.sent();
                        if (vllResponse.status !== 200) {
                            throw new Error(vllResponse.data);
                        }
                        _a.label = 3;
                    case 3:
                        if (!this.hasOpportunityPriv) return [3 /*break*/, 5];
                        oppEndpoint = 'filter/savefilters';
                        return [4 /*yield*/, _super.prototype.post.call(this, oppEndpoint, {
                                Filters: data.filterVm,
                            })];
                    case 4:
                        oppResponse = _a.sent();
                        if (oppResponse.status !== 200) {
                            throw new Error(oppResponse.data);
                        }
                        _a.label = 5;
                    case 5: return [2 /*return*/, true];
                    case 6:
                        error_4 = _a.sent();
                        console.error("Unable to save contact");
                        console.error(error_4);
                        throw error_4;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    ProfileService.prototype.saveChangePasswordVm = function (password) {
        return __awaiter(this, void 0, void 0, function () {
            var endpoint, response, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = 'profile/updatepassword';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, { Password: password })];
                    case 2:
                        response = _a.sent();
                        if (response.status === 200) {
                            return [2 /*return*/, response.data];
                        }
                        else {
                            throw new Error(response.data);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_5 = _a.sent();
                        console.error("Unable to save password");
                        console.error(error_5);
                        throw error_5;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ProfileService.prototype, "canViewVoyageLoadListReportFilters", {
        get: function () {
            return this.authService.isAuthorized('PROFILE', 'ALL', 'RF#VOYAGELIST');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProfileService.prototype, "canViewOpportunityReportFilters", {
        get: function () {
            return this.authService.isAuthorized('PROFILE', 'ALL', 'RF#CLAIMS');
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    ProfileService = __decorate([
        injectable(),
        __param(0, inject(TYPES.AuthService)),
        __metadata("design:paramtypes", [typeof (_a = typeof AuthService !== "undefined" && AuthService) === "function" ? _a : Object])
    ], ProfileService);
    return ProfileService;
}(ApiClient));
export { ProfileService };
